import { StyledRange } from "@silevis/reactgrid";
import { FieldMode } from "../../../../interfaces/interfaces";

export enum shareholderColumns {
  shareholderName = "shareholderName",
  noOfShares = "noOfShares",
  holdings = "holdings",
}

export const shareholderHeaders = [
  shareholderColumns.shareholderName,
  shareholderColumns.noOfShares,
  shareholderColumns.holdings,
];

export enum shareholderColumnTitle {
  shareholderName = "Shareholder Name",
  noOfShares = "No. of Shares",
  holdings = "Holdings (%)",
}

export const shareholderHeadersObj = {
  [shareholderColumns.shareholderName]: {
    title: shareholderColumnTitle.shareholderName,
    styles: {
      justifyContent: "flex-start",
    },
    type: "string",
    isTotal: false,
  },
  [shareholderColumns.noOfShares]: {
    title: shareholderColumnTitle.noOfShares,
    styles: {
      justifyContent: "flex-end",
    },
    type: "number",
    isTotal: true,
  },
  [shareholderColumns.holdings]: {
    title: shareholderColumnTitle.holdings,
    styles: {
      justifyContent: "flex-end",
    },
    type: "number",
    isTotal: true,
    fieldType: FieldMode.view
  },
};

export const getInitialShareholderDetails = () => {
  const rowData = [];
  const initialRow = {};
  shareholderHeaders.forEach((header) => {
    initialRow[header] = "";
  });
  rowData.push(initialRow);

  // const footer = [];
  const initalFooter = {};
  shareholderHeaders.forEach((header, index) => {
    initalFooter[header] = index === 0 ? "Total" : "-";
  });
  // footer.push(initalFooter);
  const headers = [];
  shareholderHeaders.forEach((header) => {
    headers.push({
      key: header,
      value: shareholderHeadersObj[header].title,
    });
  });

  return {
    headers,
    rowData,
    footer: initalFooter,
  };

  // const rowData = [Array(shareholderHeaders.length).fill("")];
  // const footer = ["Total", ...Array(shareholderHeaders.length - 1).fill("-")];

  // return {
  //   headers: shareholderHeaders,
  //   rowData,
  //   footer,
  // };
};

export const onAddInitialShareholderRow = () => {
  const initialRow = {};
  shareholderHeaders.forEach((header) => {
    initialRow[header] = "";
  });
  return initialRow;
};

export const getShareholdersGridInvalidRange = (gridData: any) => {
  let partialDataErrors: StyledRange[] = [];
  let totalHoldingError: StyledRange[] = [];

  let totalHolding = 0;

  gridData.rowData.forEach((row, rowIndex) => {
    // const hasData = row.some((cell) => cell.toString().trim() !== ""); // Check if row has any data
    const hasData = shareholderHeaders.some(
      (headerKey) => row[headerKey]?.toString().trim() !== ""
    ); // Check if row has any data
    if (!hasData) return;

    let emptyCells: StyledRange[] = [];
    let filledCells = 0;

    shareholderHeaders.forEach((headerKey, colIndex) => {
      // const columnKey = gridData.headers[colIndex];
      const cell = row[headerKey] || ""; // Get the cell value, default to empty string if undefined

      if (headerKey === shareholderColumns.holdings) {
        totalHolding += parseFloat(cell) || 0; // Sum holding percentages
      }

      // **Check for Empty Cells in Partially Filled Rows**
      if (hasData && cell.toString().trim() === "") {
        emptyCells.push({
          range: {
            start: { rowIndex: rowIndex + 1, columnIndex: colIndex },
            end: { rowIndex: rowIndex + 2, columnIndex: colIndex + 1 },
          },
          styles: { background: "#FDF1F1 !important" }, // Light red for missing data
        });
      } else {
        filledCells++;
      }
    });

    // If the row has some filled and some empty cells, highlight the empty ones
    if (filledCells > 0 && emptyCells.length > 0) {
      partialDataErrors.push(...emptyCells);
    }
  });

  if (Math.round(totalHolding) !== 100) {
    const holdingColumnIndex = shareholderHeaders.indexOf(
      shareholderColumns.holdings
    );
    // console.log("Holding Column Index: ", holdingColumnIndex);
    totalHoldingError.push({
      range: {
        start: {
          rowIndex: gridData.rowData.length + 1,
          columnIndex: holdingColumnIndex,
        }, // Footer Row
        end: {
          rowIndex: gridData.rowData.length + 2,
          columnIndex: holdingColumnIndex + 1,
        },
      },
      styles: { background: "#FDF1F1 !important", color: "#E94F4F !important" }, // Light red for incorrect total holding
    });
  }

  return { partialDataErrors, totalHoldingError };
};

export const getFirstShareholdersGridInvalidRange = (gridData: any) => {
  let totalHolding = 0;

  // **Step 1: Check if Total Holding is NOT 100%**
  const holdingColumnIndex = shareholderHeaders.indexOf(
    shareholderColumns.holdings
  );
  gridData.rowData.forEach((row) => {
    totalHolding += parseFloat(row[shareholderColumns.holdings]) || 0;
  });

  if (Math.round(totalHolding) !== 100) {
    return {
      range: {
        start: {
          rowIndex: gridData.rowData.length + 1,
          columnIndex: holdingColumnIndex,
        }, // Footer Row
        end: {
          rowIndex: gridData.rowData.length + 2,
          columnIndex: holdingColumnIndex + 1,
        },
      },
      styles: { background: "#FDF1F1", color: "#E94F4F" }, // Light red for incorrect total holding
      message: "Total holding must be 100%",
    };
  }

  // **Step 2: Check for Empty Cells in Partially Filled Rows**
  for (let rowIndex = 0; rowIndex < gridData.rowData.length; rowIndex++) {
    const row = gridData.rowData[rowIndex];
    const hasData = shareholderHeaders.some(
      (headerKey) => row[headerKey]?.toString().trim() !== ""
    ); // Check if row has any data
    if (!hasData) return;

    let emptyCells = 0;
    let firstEmptyCell = null;

    shareholderHeaders.forEach((headeKey, colIndex) => {
      const cell = row[headeKey] || ""; // Get the cell value, default to empty string if undefined
      if (cell.toString().trim() === "") {
        emptyCells++;

        // Capture the first empty cell found
        if (!firstEmptyCell) {
          firstEmptyCell = {
            range: {
              start: { rowIndex: rowIndex + 1, columnIndex: colIndex },
              end: { rowIndex: rowIndex + 2, columnIndex: colIndex + 1 },
            },
            styles: { background: "#FDF1F1" }, // Light red for missing data
            message: "Incomplete row: Fill all cells",
          };
        }
      }
    });

    if (emptyCells > 0) {
      return firstEmptyCell; // Return the first missing cell found
    }
  }

  return null; // No errors found
};
